import { Checkbox } from "antd";
import classNames from "classnames";
import React, { useCallback, useMemo, useState } from "react";

import styles from "./FilterColumn.module.scss";

function FilterColumn({ filterName, checked, onChange, onReset, list }) {
  const [searchValue, setSearchValue] = useState("");

  const filteredList = useMemo(
    () => list.filter((event) => (event.label || "").toLowerCase().includes(searchValue.toLowerCase())),
    [list, searchValue],
  );

  const searchEventFun = useCallback((searchValue) => {
    setSearchValue(searchValue);
  }, []);

  return (
    <div>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{filterName}</div>
        <button onClick={onReset} className={classNames("reset-btn", styles.resetButton)}>
          Reset
        </button>
      </div>
      <div className="custom-checkbox-group-container">
        <div className="field-container">
          <input
            type="text"
            onChange={(e) => searchEventFun(e.target.value)}
            placeholder="Search"
            className="searchInput-field"
          />
        </div>
        <div className="checkbox-container-main pb-3">
          <div className={classNames("long", "filters-events-list", "styled-scroll", styles.overflow400)}>
            <div className="custom-radio-group pt-2 two-column-modal-icon">
              <div className="custom-radio-group pt-2 two-column-modal-icon checkbox-container-flex">
                {filteredList.map((event) => {
                  if (event) {
                    return (
                      <div key={event.value}>
                        <Checkbox
                          checked={checked[event.value] || false}
                          className="text-capitalize"
                          onChange={(e) => onChange(event.value, e.target.checked)}
                        >
                          {event.label}
                        </Checkbox>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

FilterColumn.propTypes = {};

export default FilterColumn;
